import { isNonEmptyString } from '@sniptt/guards';

import { type CommandMenuCommand } from '@/command-menu/types/CommandMenuCommand';
import { normalizeSearchText } from '@/command-menu/utils/normalizeSearchText';

export const filterCommandMenuCommands = (
  commands: CommandMenuCommand[],
  searchQuery: string,
) => {
  const normalizedSearchQuery = normalizeSearchText(searchQuery);

  if (!isNonEmptyString(normalizedSearchQuery)) {
    return commands;
  }

  return commands.filter((command) =>
    [command.label, ...(command.keywords ?? [])].some((searchableText) =>
      normalizeSearchText(searchableText).includes(normalizedSearchQuery),
    ),
  );
};
